import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from 'reselect';
import { changeSidebarVisibility } from '../rtk/slices/thunks';
import { selectOpenPositions } from '../rtk/slices/openPositionsSlice/openPositionsSlice';
import LightDark from '../Components/Common/LightDark';


// Import images
// import logoSm from "../assets/images/logo-sm.png";
// import logoDark from "../assets/images/t-logo-h.png";
// import logoLight from "../assets/images/t-logo-h.png";
import { logoSm } from '../utils/config';
import { logoDark } from '../utils/config';
import { logoLight } from '../utils/config';

// Import components
import ProfileDropdown from '../Components/Common/ProfileDropdown';
import useWindowSize from '../Components/Hooks/useWindowSize';

const Header = ({ onChangeLayoutMode, layoutModeType, headerClass }) => {
    const dispatch = useDispatch();
    const location = useLocation();
    const { tP } = useSelector(selectOpenPositions);
    const totalProfit = tP;
    const { width } = useWindowSize();
    const isMobile = width <= 767; // Mobile breakpoint

    const selectDashboardData = createSelector(
        (state) => state.Layout,
        (state) => ({
            sidebarVisibilitytype: state.sidebarVisibilitytype
        })
    );

    const { sidebarVisibilitytype } = useSelector(selectDashboardData);

    const [search, setSearch] = useState(false);
    const toogleSearch = () => {
        setSearch(!search);
    };

    const toogleMenuBtn = () => {
        const windowSize = document.documentElement.clientWidth;
        dispatch(changeSidebarVisibility("show"));

        if (windowSize > 767)
            document.querySelector(".hamburger-icon").classList.toggle('open');

        if (document.documentElement.getAttribute('data-layout') === "horizontal") {
            document.body.classList.toggle("menu");
        }

        if (sidebarVisibilitytype === "show" && (document.documentElement.getAttribute('data-layout') === "vertical" || document.documentElement.getAttribute('data-layout') === "semibox")) {
            if (windowSize < 1025 && windowSize > 767) {
                document.body.classList.remove('vertical-sidebar-enable');
                document.documentElement.setAttribute('data-sidebar-size', document.documentElement.getAttribute('data-sidebar-size') === 'sm' ? '' : 'sm');
            } else if (windowSize > 1025) {
                document.body.classList.remove('vertical-sidebar-enable');
                document.documentElement.setAttribute('data-sidebar-size', document.documentElement.getAttribute('data-sidebar-size') === 'sm' ? 'sm' : 'sm');
                // document.documentElement.setAttribute('data-sidebar-size', document.documentElement.getAttribute('data-sidebar-size') === 'lg' ? 'sm' : 'sm');
            } else if (windowSize <= 767) {
                document.body.classList.add('vertical-sidebar-enable');
                document.documentElement.setAttribute('data-sidebar-size', 'sm');
                // document.documentElement.setAttribute('data-sidebar-size', 'lg');
            }
        }

        if (document.documentElement.getAttribute('data-layout') === "twocolumn") {
            document.body.classList.toggle('twocolumn-panel');
        }
    };

    const isDashboardTab1 = location.pathname === '/trade' && location.search === '?tab=1';
    const isDashboardTab2 = location.pathname === '/trade' && location.search === '?tab=2';
    const isDashboardTab5 = location.pathname === '/trade' && location.search === '?tab=5';

    return (
        <React.Fragment>
            <header id="page-topbar" className={isMobile ? `${headerClass} ` : 'd-none'}>
                <div className="layout-width">
                    <div className="navbar-header">
                        <div className="d-none">

                            <div className="navbar-brand-box horizontal-logo">
                                <Link to="/" className="logo logo-dark">
                                    <span className="logo-sm">
                                        <img src={logoSm} alt="" height="22" />
                                    </span>
                                    <span className="logo-lg">
                                        <img src={logoDark} alt="" height="30" />
                                    </span>
                                </Link>

                                <Link to="/" className="logo logo-light">
                                    <span className="logo-sm">
                                        <img src={logoSm} alt="" height="22" />
                                    </span>
                                    <span className="logo-lg">
                                        <img src={logoLight} alt="" height="30" />
                                    </span>
                                </Link>
                            </div>

                            <button
                                onClick={toogleMenuBtn}
                                type="button"
                                className="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger d-none"
                                id="topnav-hamburger-icon">
                                <span className="hamburger-icon">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </span>
                            </button>
                        </div>

                        <LightDark
                            layoutMode={layoutModeType}
                            onChangeLayoutMode={onChangeLayoutMode}
                        />

                        <div className="dflex">
                            {isDashboardTab1 && (
                                <h5 className='fs-5 fw-bold mb-0'>
                                    Quotes
                                </h5>
                            )}
                            {isDashboardTab2 && totalProfit !== 0 && (
                                <h5
                                    className='fs-5 fw-semibold mb-0'
                                    style={{ color: totalProfit < 0 ? '#DC3A48' : '#3577f1' }}
                                >
                                    {parseFloat(totalProfit).toFixed(2)} USD

                                </h5>
                            )}
                            {isDashboardTab5 && (
                                <h5 className='fs-5 fw-semibold mb-0'>
                                    Settings
                                </h5>
                            )}
                        </div>

                        <div className="d-flex align-items-center">
                            {/* ProfileDropdown */}
                            {/* Dark/Light Mode set */}

                            <ProfileDropdown />
                        </div>
                    </div>
                </div>
            </header>
        </React.Fragment>
    );
};

export default Header;
